import { useDispatch, useSelector } from 'react-redux';

import { selectBuildingCard } from 'shared/selectors/buildingCard';
import { selectBuildingOffers } from 'shared/selectors/buildingOffers';
import { setOffersFilters } from 'shared/slices/buildingOffers';
import type { TOffersPropertyType } from 'shared/types/buildingOffers';
import type { TDispatch } from 'shared/types/redux';
import { getAnchorPropertyTypes, selectOffersAnchor } from 'shared/utils/buildingOffers';
import { getDocumentTop, getFloatingHeaderHeight } from 'shared/utils/floatingHeader';

import { OffersAnchors } from './OffersAnchors';

/** Отступ над предложениями сверх высоты плавающей шапки (`onload.html` монолита: `45 + scrollHeight`) */
const OFFERS_SCROLL_GAP = 45;

/** Плавная прокрутка к предложениям (`smooth_scroll.ts` монолита) с поправкой на плавающую шапку */
function scrollToOffers() {
  const section = document.getElementById('all-offers');

  if (section) {
    window.scrollTo({
      top: getDocumentTop(section) - OFFERS_SCROLL_GAP - getFloatingHeaderHeight(),
      behavior: 'smooth',
    });
  }
}

const OffersAnchorsBlock = ({ propertyTypes }: { propertyTypes: TOffersPropertyType[] }) => {
  const { offerCategories } = useSelector(selectBuildingCard);
  const { filters } = useSelector(selectBuildingOffers);
  const dispatch = useDispatch<TDispatch>();

  const handleSelect = (propertyType: TOffersPropertyType) => {
    dispatch(setOffersFilters(selectOffersAnchor(offerCategories, filters, propertyType)));
    scrollToOffers();
  };

  return <OffersAnchors propertyTypes={propertyTypes} onSelect={handleSelect} />;
};

export const OffersAnchorsContainer = () => {
  const { offerCategories } = useSelector(selectBuildingCard);
  const propertyTypes = getAnchorPropertyTypes(offerCategories);

  return propertyTypes.length ? <OffersAnchorsBlock propertyTypes={propertyTypes} /> : null;
};
